module.exports = __webpack_public_path__ + "img/pantalla-3-5.b6ce2bed.png";